import { AxiosResponse } from 'axios';
import { defer, lastValueFrom, map } from 'rxjs';
import { ApiConfig, ErrorResponse, Response } from './api';
import TokenManagerInstance from './tokenManagerInstance';

class AdminApi {
  private parseResponse = <U>(response: AxiosResponse<U>) => response.data;

  readonly prefix: string;
  readonly baseUrl: string;
  readonly formatter: (response: AxiosResponse<any, any>) => any;
  readonly tokenManager: TokenManagerInstance;
  readonly refreshUrl?: string;

  constructor(config: ApiConfig) {
    this.prefix = config.prefix;
    this.baseUrl = config.baseUrl;
    this.formatter = config.formatter;
    this.refreshUrl = config.refreshUrl;
    this.tokenManager = new TokenManagerInstance({
      prefix: this.prefix,
      baseUrl: this.baseUrl,
      refreshUrl: this.refreshUrl,
    });
  }

  async GET<T, U>(
    url: string,
    params?: T
  ): Promise<Response<U> | ErrorResponse> {
    try {
      const instance = await this.tokenManager.instance();
      const result = await lastValueFrom(
        defer(() => instance.get(url, { params })).pipe(
          map((response) => response.data)
        )
      );

      return {
        code: 200000,
        statusCode: 200,
        message: 'OK',
        result,
      };
    } catch (err) {
      // if (axios.isAxiosError(err)) {
      //   throw err.response?.data;
      // }

      throw err;
    }
  }

  async POST<T, U>(
    url: string,
    data?: T,
    config?: any
  ): Promise<Response<U> | ErrorResponse> {
    try {
      const instance = await this.tokenManager.instance();
      const result = await lastValueFrom(
        defer(() =>
          instance.post(url, data, config).then(this.parseResponse)
        ).pipe(map(this.formatter))
      );

      return {
        code: 200000,
        statusCode: 200,
        message: 'OK',
        result,
      };
    } catch (err) {
      // if (axios.isAxiosError(err)) {
      //   throw err.response?.data;
      // }

      throw err;
    }
  }

  async PUT<T, U>(
    url: string,
    data?: T,
    config?: any
  ): Promise<Response<U> | ErrorResponse> {
    try {
      const instance = await this.tokenManager.instance();
      const result = await lastValueFrom(
        defer(() =>
          instance.put(url, data, config).then(this.parseResponse)
        ).pipe(map(this.formatter))
      );

      return {
        code: 200000,
        statusCode: 200,
        message: 'OK',
        result,
      };
    } catch (err) {
      // if (axios.isAxiosError(err)) {
      //   throw err.response?.data;
      // }

      throw err;
    }
  }

  async PATCH<T, U>(
    url: string,
    data?: T,
    config?: any
  ): Promise<Response<U> | ErrorResponse> {
    try {
      const instance = await this.tokenManager.instance();
      const result = await lastValueFrom(
        defer(() =>
          instance.patch(url, data, config).then(this.parseResponse)
        ).pipe(map(this.formatter))
      );

      return {
        code: 200000,
        statusCode: 200,
        message: 'OK',
        result,
      };
    } catch (err) {
      // if (axios.isAxiosError(err)) {
      //   throw err.response?.data;
      // }

      throw err;
    }
  }

  async DELETE<T, U>(
    url: string,
    config?: T
  ): Promise<Response<U> | ErrorResponse> {
    try {
      const instance = await this.tokenManager.instance();
      const result = await lastValueFrom(
        defer(() => instance.delete(url, config).then(this.parseResponse)).pipe(
          map(this.formatter)
        )
      );

      return {
        code: 200000,
        statusCode: 200,
        message: 'OK',
        result,
      };
    } catch (err) {
      // if (axios.isAxiosError(err)) {
      //   throw err.response?.data;
      // }

      throw err;
    }
  }
}

export default AdminApi;
